module.exports = __webpack_public_path__ + "img/HYDE BEACH HOUSE.1e16f426.png";